import { useContext } from 'react';
import { useProjectContext } from '@gonfalon/app-context/useProjectContext';

import { VegaProjectContext } from './VegaProjectProvider';

export function useProjectId() {
  const project = useContext(VegaProjectContext);
  const routeContext = useProjectContext({ optional: true });

  if (project) {
    return project;
  }

  if (routeContext) {
    return { projectId: routeContext.project._id, projectKey: routeContext.project.key };
  }

  throw new Error('project must be provided');
}
